import { sortBy } from "@suse-o11y/sort-by";
import { z } from "zod";

import { type DashboardListVariableSort, dashboardListVariableSortSchema } from "./_dashboard-list-variable";

interface Value {
	value: string | number;
	label?: string | number;
}

export const Sort = dashboardListVariableSortSchema.enum;

const numericalAscSchema = z.coerce.number().catch(Number.POSITIVE_INFINITY);
const numericalDescSchema = z.coerce.number().catch(Number.NEGATIVE_INFINITY);

export const sortDashboardListValues = (
	values: Array<Value>,
	sort: DashboardListVariableSort = Sort.None,
): Array<Required<Value>> => {
	const valuesWithLabels = values.map(({ value, label = value }) => ({ value, label }));

	switch (sort) {
		case Sort.None: {
			return valuesWithLabels;
		}

		case Sort.AlphabeticalAsc: {
			return sortBy(valuesWithLabels, [({ label }) => label, "asc"]);
		}

		case Sort.AlphabeticalDesc: {
			return sortBy(valuesWithLabels, [({ label }) => label, "desc"]);
		}

		case Sort.AlphabeticalCiAsc: {
			return sortBy(valuesWithLabels, [({ label }) => label.toLocaleString().toLocaleLowerCase(), "asc"]);
		}

		case Sort.AlphabeticalCiDesc: {
			return sortBy(valuesWithLabels, [({ label }) => label.toLocaleString().toLocaleLowerCase(), "desc"]);
		}

		case Sort.NumericalAsc: {
			return sortBy(valuesWithLabels, [({ label }) => numericalAscSchema.parse(label), "asc"]);
		}

		case Sort.NumericalDesc: {
			return sortBy(valuesWithLabels, [({ label }) => numericalDescSchema.parse(label), "desc"]);
		}
	}
};
